import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { OperationActive } from '../../enum/operation-active.enum';
import { IValuation } from '../../interfaces/valuation.interface';
import { CalculatorPresenter } from './calculator.presenter';
import { ICalculatorKeyup } from '../../interfaces/calculator-keyup.interface';
import { RoblexCodeStatus } from '../../enum';

@Component({
    selector: 'roblex-calculator',
    templateUrl: './calculator.component.html',
    styleUrls: ['./calculator.component.scss'],
    providers: [],
    host: {
        class: 'd-block',
    },
})
export class CalculatorComponent implements OnInit, OnChanges {
    /**
     * Roblex code status of changes form component
     */
    roblexCodeStatus = RoblexCodeStatus;
    /**
     * Change  of calculator component
     */
    change = true;
    /**
     * Interval keyup of calculator component
     */
    intervalKeyup: any;
    /**
     * Input valuation of calculator component
     */
    @Input() loading: boolean | null;
    /**
     * Input rotate of calculator component
     */
    @Input() rotate: boolean | null;
    /**
     * Input valuation of calculator component
     */
    @Input() valuation: IValuation;
    /**
     * Input label send of calculator component
     */
    @Input() labelSend: string = 'Envío';
    /**
     * Input label receive of calculator component
     */
    @Input() labelReceive: string = 'Recibo';
    @Input() labelCode: string = 'Código Promocional';
    @Input() hasPromotionalCode: boolean = false;
    /**
     * Validated  of changes form calculator component
     */
    @Input() validated: RoblexCodeStatus = RoblexCodeStatus.initial;
    /**
     * Output keyup send of calculator component
     */
    @Output() keyupSend: EventEmitter<ICalculatorKeyup> = new EventEmitter();
    /**
     * Output keyup receive of calculator component
     */
    @Output() keyupReceive: EventEmitter<ICalculatorKeyup> = new EventEmitter();
    /**
     * Output change currency of calculator component
     */
    @Output()
    changeCurrency: EventEmitter<ICalculatorKeyup> = new EventEmitter();
    /**
     * Output start operations of calculator component
     */
    @Output() startOperations: EventEmitter<void> = new EventEmitter();
    @Output() validateCode: EventEmitter<void> = new EventEmitter();
    @Output() backSpaceCode: EventEmitter<void> = new EventEmitter();
    /**
     * Creates an instance of calculator component.
     * @param calculatorPresenter CalculatorPresenter
     */
    constructor(public calculatorPresenter: CalculatorPresenter) {
        // this.initForm();
    }
    /**
     * on init
     */
    ngOnInit(): void {
        //
    }
    /**
     * on changes
     * @param changes SimpleChanges
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (!changes.loading?.currentValue) {
            this.calculatorPresenter.Enabled();
        } else {
            this.calculatorPresenter.Disabled();
        }
        // }
    }
    /**
     * Determines whether change currency on
     */
    onChangeCurrency() {
        this.changeCurrency.emit({
            active: OperationActive.SEND,
            currencyName: this.calculatorPresenter.exchangeCurrencyName.value,
            exchangeCurrencyName: this.calculatorPresenter.currencyName.value,
            value: +this.calculatorPresenter.receive,
        });
    }
    /**
     * Determines whether keyup send on
     * @param value: number
     */
    onKeyupSend(value: number) {
        this.keyupSend.emit({
            active: OperationActive.SEND,
            value,
        });
    }
    /**
     * Determines whether keyup receive on
     * @param value: number
     */
    onKeyupReceive(value: number) {
        this.keyupReceive.emit({
            active: OperationActive.RECEIVE,
            value,
        });
    }
    /**
     * Determines whether click start operations on
     */
    onClickStartOperations() {
        this.startOperations.emit();
    }
    onSuffixPromotionCode(){
        this.validateCode.emit();
    }
    onBackspace(){
        this.backSpaceCode.emit();
    }
}
